<template>
  <vue3-chart-js v-bind="{ ...barChart }" />
</template>

<script>
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";
import { moneyFormat } from "../../Pages/Cukai/CukaiTanah/helper";

export default {
  name: "ChartBarNaked",
  components: {
    Vue3ChartJs,
  },
  props: {
    graph : {
      type:Object,
      default: {
        title: "Kutipan",
        difference:{
        amount:0,
            percentage:0
            },
            labels:[],
            data : [],
        },
    },
  },

  methods: {

  },
  setup(props) {
    let colors = []
    function generateRandomNumbers(min = 54, max = 235) {
      let difference = max - min;
      let rand = Math.random();
      rand = Math.floor( rand * difference);
      rand = rand + min;
      return rand;
    }

    function generateRandomColors() {
      return "rgba("+generateRandomNumbers()+", "+generateRandomNumbers()+", "+generateRandomNumbers()+", 0.9)"
    }

    function generateBarColorList(){
        let maxLength = props.graph.data.length
        let start = 0
        
        while(start < maxLength)
        {
          colors.push(generateRandomColors())
          start++
        }
    }

    generateBarColorList()
    const barChart = {
      type: "bar",
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
          datalabels: {
            color: 'white',
            font: {
              weight: 'bold'
            },
            formatter: (value, context) => {
              return `RM ${moneyFormat(value)}`
            }
          }
        },
        scales: {
          x: {
            ticks : {
              color:"white"
            }
          },
          y: {
            display: false,
            ticks: {
              callback: function (value) {
                return `RM ${value.toFixed(2)}`;
              },
            },
          },
        },
      },
      data: {
        labels: props.graph.labels,
        datasets: [
          {
            label: props.graph.title,
            backgroundColor: ['#4d2b89','#39843c'],
            data: props.graph.data,
          },
        ],
      },
    }

    return {
      barChart,
    };
  },
};
</script>
